var _defs, _rect, _rect2, _path, _path2, _path3, _rect3, _path4, _path5, _path6, _ellipse, _polygon, _path7, _path8, _path9, _rect4, _rect5, _rect6, _rect7, _path10, _path11, _rect8, _rect9, _path12, _rect10, _circle, _g, _path13, _path14, _line, _line2, _line3, _line4, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg505Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2388 1668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-3,.cls-6{fill:none;}.cls-2{fill:#39a2da;}.cls-10,.cls-3,.cls-6{stroke:#2e82af;}.cls-10,.cls-11,.cls-3,.cls-6{stroke-miterlimit:10;}.cls-10,.cls-11,.cls-3{stroke-width:11px;}.cls-4{fill:#2e82af;}.cls-5{fill:#d1e5f0;}.cls-6{stroke-width:20px;}.cls-7{fill:#9cd0ed;}.cls-8{fill:#215673;}.cls-9{clip-path:url(#clip-path);}.cls-10,.cls-11{stroke-linecap:round;}.cls-11{stroke:#39a2da;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 904.66,
    y: 480.14,
    width: 54.58,
    height: 210.76
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Batch 2-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1663.04,
    y: 1270.21,
    width: 14.51,
    height: 33.49,
    rx: 6.36
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1690.94,
    y: 1270.21,
    width: 14.51,
    height: 33.49,
    rx: 6.36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1527.36,706.53H1636.5a47.13,47.13,0,0,1,47.12,47.13v470.78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1655,1187h34.11a34.73,34.73,0,0,1,34.73,34.73v26.53a34.73,34.73,0,0,1-34.73,34.73H1655a10.41,10.41,0,0,1-10.41-10.41v-75.17A10.41,10.41,0,0,1,1655,1187Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1162.47,718.58a16,16,0,0,1-16,16H945.24a16,16,0,0,1-16-16V406.51a16.06,16.06,0,0,1,16-16.05l33.46-.52"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 428.28,
    y: 774.43,
    width: 1187.61,
    height: 60.27,
    rx: 26.97
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M685.79,546.84c2.05,4-2.87,8-7,5.64-38.12-21.58-59.78-67-49-107.45,6.76-25.41,24.12-47.12,36.31-70.74,8.57-16.62,14.38-36,11.92-53.83-.65-4.72,6.05-7,8.85-3A92.66,92.66,0,0,1,704.05,371c-.29,41.36-28.9,78.86-30.95,120.18C672.13,510.7,677.42,530.43,685.79,546.84Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M728.89,549c.89,2-1.5,4-3.56,2.9-18.67-9.56-28.07-31.72-27.22-51.95.93-22.43,11.45-43.4,20.21-64.34,7.51-17.94,13.9-37.3,11.88-56.19-.26-2.43,3.3-3.52,4.65-1.42,9.86,15.29,10.92,35.1,7.58,53-4,21.21-13.18,41.32-17.46,62.48C721.17,512.36,721.93,533.3,728.89,549Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M763.17,541.27c.54,2.48-2.9,3.92-4.55,1.91-10.72-13.08-14.33-30.89-12.37-47.44,1.41-11.94,5.33-23.41,10.31-34.54,1.16-2.62,5.39-1.48,4.88,1.31A200.85,200.85,0,0,0,763.17,541.27Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 566.52,
    cy: 673.39,
    rx: 50.23,
    ry: 54.11,
    transform: "matrix(0.41, -0.91, 0.91, 0.41, -278.64, 918.56)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1022.08 1261.08 1169.42 834.7 874.75 834.7 1022.08 1261.08"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M990.23,1074.22l-100,289.49a33.7,33.7,0,0,0,31.85,44.71h200.07a33.7,33.7,0,0,0,31.85-44.71l-100-289.49C1043.48,1044,1000.69,1044,990.23,1074.22Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M874.75,606.69v22A121.65,121.65,0,0,1,753.05,750.4H688.23A121.7,121.7,0,0,1,566.52,628.71v-22a10.32,10.32,0,0,1,10.31-10.32h287.6A10.32,10.32,0,0,1,874.75,606.69Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M721.1,596.37v154H688.23A121.7,121.7,0,0,1,566.52,628.71v-22a10.32,10.32,0,0,1,10.31-10.32Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1812.3,
    y: 1087.02,
    width: 156.26,
    height: 156.26,
    rx: 11.06
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 622.41,
    y: 745.41,
    width: 196.45,
    height: 29.02,
    rx: 12.98
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1869.23,
    y: 1148.41,
    width: 14.51,
    height: 33.49,
    rx: 6.36
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1897.13,
    y: 1148.41,
    width: 14.51,
    height: 33.49,
    rx: 6.36
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1511.12,774.43H1123.76a44.85,44.85,0,0,1-43.57-55.5l71.89-294.26a44.85,44.85,0,0,1,43.57-34.2h240.23a44.84,44.84,0,0,1,43.45,33.74l75.25,294.25A44.85,44.85,0,0,1,1511.12,774.43Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1670.15,352.23V425.4a34.33,34.33,0,0,1-34.32,34.33h-83.22a34.33,34.33,0,0,1-34.32-34.33V395a42.74,42.74,0,0,0-42.74-42.74H1159.33A42.73,42.73,0,0,0,1116.6,395V425.4a34.33,34.33,0,0,1-34.33,34.33H999.05a34.33,34.33,0,0,1-34.32-34.33V352.23A129.47,129.47,0,0,1,1094.2,222.75h446.48A129.48,129.48,0,0,1,1670.15,352.23Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1230.11,
    y: 371.21,
    width: 38.51,
    height: 38.51,
    rx: 5.69
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1366.27,
    y: 371.21,
    width: 38.51,
    height: 38.51,
    rx: 5.69
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1310.36,390.47v384h-186.6a44.85,44.85,0,0,1-43.57-55.5l71.89-294.26a44.85,44.85,0,0,1,43.57-34.2Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1527.36,
    y: 687.28,
    width: 38.51,
    height: 38.51,
    rx: 5.69
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 1317.44,
    cy: 585.52,
    r: 130.62
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 849.61,
    y1: 464.12,
    x2: 888.63,
    y2: 452.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 910.8,
    y1: 464.12,
    x2: 949.82,
    y2: 452.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 971.98,
    y1: 464.12,
    x2: 1011,
    y2: 452.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 849.61,
    y1: 498.17,
    x2: 888.63,
    y2: 486.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 910.8,
    y1: 498.17,
    x2: 949.82,
    y2: 486.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 971.98,
    y1: 498.17,
    x2: 1011,
    y2: 486.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 849.61,
    y1: 532.23,
    x2: 888.63,
    y2: 520.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 910.8,
    y1: 532.23,
    x2: 949.82,
    y2: 520.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 971.98,
    y1: 532.23,
    x2: 1011,
    y2: 520.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 849.61,
    y1: 566.28,
    x2: 888.63,
    y2: 554.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 910.8,
    y1: 566.28,
    x2: 949.82,
    y2: 554.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 971.98,
    y1: 566.28,
    x2: 1011,
    y2: 554.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 849.61,
    y1: 600.34,
    x2: 888.63,
    y2: 588.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 910.8,
    y1: 600.34,
    x2: 949.82,
    y2: 588.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 971.98,
    y1: 600.34,
    x2: 1011,
    y2: 588.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 849.61,
    y1: 634.39,
    x2: 888.63,
    y2: 622.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 910.8,
    y1: 634.39,
    x2: 949.82,
    y2: 622.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 971.98,
    y1: 634.39,
    x2: 1011,
    y2: 622.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 849.61,
    y1: 668.45,
    x2: 888.63,
    y2: 656.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 910.8,
    y1: 668.45,
    x2: 949.82,
    y2: 656.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 971.98,
    y1: 668.45,
    x2: 1011,
    y2: 656.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 849.61,
    y1: 702.5,
    x2: 888.63,
    y2: 690.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 910.8,
    y1: 702.5,
    x2: 949.82,
    y2: 690.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 971.98,
    y1: 702.5,
    x2: 1011,
    y2: 690.61
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1310.36,222.75V352.23h-151A42.73,42.73,0,0,0,1116.6,395V425.4a34.33,34.33,0,0,1-34.33,34.33H999.05a34.33,34.33,0,0,1-34.32-34.33V352.23A129.47,129.47,0,0,1,1094.2,222.75Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1270.31,638.66a70.44,70.44,0,0,1,91.07,1.52"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 1255.14,
    y1: 548.76,
    x2: 1285.47,
    y2: 579.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 1285.47,
    y1: 548.76,
    x2: 1255.14,
    y2: 579.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 1349.41,
    y1: 548.76,
    x2: 1379.75,
    y2: 579.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 1379.75,
    y1: 548.76,
    x2: 1349.41,
    y2: 579.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M964.73,409.72h126.86a25,25,0,0,1,25,25v0a25,25,0,0,1-25,25H964.73a0,0,0,0,1,0,0v-50A0,0,0,0,1,964.73,409.72Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1518.29,409.72h126.86a25,25,0,0,1,25,25v0a25,25,0,0,1-25,25H1518.29a0,0,0,0,1,0,0v-50a0,0,0,0,1,0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg505Error);
export default __webpack_public_path__ + "static/media/505Error.72aaf30eac7dbd8b57aefb43c7e0a973.svg";
export { ForwardRef as ReactComponent };